export const mockLogs = [
  {
    id: 10001,
    logType: '操作日志' as const,
    module: '商品管理',
    operationType: '新增',
    targetId: 'PROD-2024-001',
    targetName: '云电脑标准版',
    beforeContent: '',
    afterContent: JSON.stringify({
      name: '云电脑标准版',
      price: 299,
      cpu: '4核',
      memory: '8GB',
      storage: '100GB'
    }, null, 2),
    operatorId: 'ADM-001',
    operatorName: '张伟',
    operatorRole: '超级管理员',
    ip: '192.168.1.100',
    deviceInfo: 'Windows 10 / Chrome 120.0.0',
    operationTime: '2024-01-15 14:23:45'
  },
  {
    id: 10002,
    logType: '操作日志' as const,
    module: '租户管理',
    operationType: '修改',
    targetId: 'TENANT-2024-005',
    targetName: '山东科技大学',
    beforeContent: JSON.stringify({
      status: '正常',
      maxUsers: 1000
    }, null, 2),
    afterContent: JSON.stringify({
      status: '正常',
      maxUsers: 1500
    }, null, 2),
    operatorId: 'ADM-002',
    operatorName: '李娜',
    operatorRole: '系统管理员',
    ip: '192.168.1.105',
    deviceInfo: 'macOS 14.0 / Safari 17.0',
    operationTime: '2024-01-15 13:45:12'
  },
  {
    id: 10003,
    logType: '登录日志' as const,
    module: '系统登录',
    operatorId: 'ADM-003',
    operatorName: '王强',
    operatorRole: '运营管理员',
    ip: '192.168.1.120',
    deviceInfo: 'Windows 11 / Edge 120.0.0',
    operationTime: '2024-01-15 09:15:30'
  },
  {
    id: 10004,
    logType: '操作日志' as const,
    module: '资源管理',
    operationType: '删除',
    targetId: 'SERVER-2024-008',
    targetName: '服务器-北京-03',
    beforeContent: JSON.stringify({
      name: '服务器-北京-03',
      status: '离线',
      cpu: '32核',
      memory: '128GB'
    }, null, 2),
    afterContent: '',
    operatorId: 'ADM-001',
    operatorName: '张伟',
    operatorRole: '超级管理员',
    ip: '192.168.1.100',
    deviceInfo: 'Windows 10 / Chrome 120.0.0',
    operationTime: '2024-01-15 11:30:22'
  },
  {
    id: 10005,
    logType: '操作日志' as const,
    module: '商品管理',
    operationType: '启用',
    targetId: 'PROD-2024-015',
    targetName: '云电脑旗舰版',
    beforeContent: JSON.stringify({ status: '禁用' }, null, 2),
    afterContent: JSON.stringify({ status: '启用' }, null, 2),
    operatorId: 'ADM-004',
    operatorName: '赵敏',
    operatorRole: '商品管理员',
    ip: '192.168.1.88',
    deviceInfo: 'Windows 10 / Firefox 121.0',
    operationTime: '2024-01-14 16:20:15'
  },
  {
    id: 10006,
    logType: '登录日志' as const,
    module: '系统登录',
    operatorId: 'ADM-005',
    operatorName: '刘洋',
    operatorRole: '客服管理员',
    ip: '192.168.1.66',
    deviceInfo: 'macOS 13.0 / Chrome 120.0.0',
    operationTime: '2024-01-14 08:45:00'
  },
  {
    id: 10007,
    logType: '操作日志' as const,
    module: '订单管理',
    operationType: '修改',
    targetId: 'ORDER-2024-10256',
    targetName: '订单-10256',
    beforeContent: JSON.stringify({
      status: '待支付',
      amount: 299
    }, null, 2),
    afterContent: JSON.stringify({
      status: '已取消',
      amount: 299,
      cancelReason: '用户主动取消'
    }, null, 2),
    operatorId: 'ADM-002',
    operatorName: '李娜',
    operatorRole: '系统管理员',
    ip: '192.168.1.105',
    deviceInfo: 'macOS 14.0 / Safari 17.0',
    operationTime: '2024-01-14 15:10:33'
  },
  {
    id: 10008,
    logType: '操作日志' as const,
    module: '权限管理',
    operationType: '新增',
    targetId: 'ROLE-2024-003',
    targetName: '财务管理员',
    beforeContent: '',
    afterContent: JSON.stringify({
      name: '财务管理员',
      permissions: ['账单查看', '账单导出', '充值审核']
    }, null, 2),
    operatorId: 'ADM-001',
    operatorName: '张伟',
    operatorRole: '超级管理员',
    ip: '192.168.1.100',
    deviceInfo: 'Windows 10 / Chrome 120.0.0',
    operationTime: '2024-01-13 10:25:18'
  }
];

export const logTypeOptions = ['操作日志', '登录日志'];

export const moduleOptions = [
  '资源管理',
  '商品管理',
  '租户管理',
  '订单管理',
  '权限管理',
  '用户管理',
  '系统登录'
];

export const operationTypeOptions = [
  '新增',
  '修改',
  '删除',
  '启用',
  '禁用',
  '导出',
  '导入'
];
